function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M48 144h47c26.51 0 48-21.49 48-48V49c0-26.51-21.49-48-48-48H0v95c0 26.51 21.49 48 48 48z",
  fill: "#C59353",
  fillRule: "evenodd"
});

function SvgGroup1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 144"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDMgMTQ0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iI0M1OTM1MyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik04NjIgMTIxNWg0N2MyNi41MSAwIDQ4IDIxLjQ5IDQ4IDQ4djQ3YzAgMjYuNTEtMjEuNDkgNDgtNDggNDhoLTk1di05NWMwLTI2LjUxIDIxLjQ5LTQ4IDQ4LTQ4eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgxNCAtMTIxNCkgbWF0cml4KDEgMCAwIC0xIDAgMjU3MykiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgGroup1 as ReactComponent };